// GĐ4b TRỢ LÝ AI CỦA BOSS — phía WEB (docs/thiet-ke-gd4b-tro-ly.md mục 6): trang "Trợ lý" (#/tro-ly, menu Vận hành). Hội thoại (người phải / trợ lý
// trái), chip NGUỒN là liên kết thật (lần chạy, kịch bản…), THẺ ĐỀ XUẤT (chữ do máy chủ viết + nút làm / Bỏ qua → kết quả + liên kết; chạy thật /
// duyệt chỉ là liên kết), "Trợ lý đang trả lời…" (F5 không mất: hỏi lại máy chủ theo id), tin lỗi + Thử lại, "Xem tin cũ hơn", gợi ý khi trống.
// Ô gõ đếm theo KÝ TỰ (emoji = 1), Enter gửi / Shift+Enter xuống dòng (không gửi khi đang gõ bộ gõ tiếng Việt), nút đang gửi thì khoá (bấm 2 lần = 1),
// mất mạng → báo lỗi và GIỮ chữ trong ô. Super chọn "Hội thoại của" một Boss để xem (chỉ xem). Mọi chữ từ máy chủ dựng bằng textContent.
import { api, errMsg } from "../api";
import { busy, clear, gen, h, toast } from "../dom";
import { fmtTime } from "../format";
import { isSuper, store } from "../store";
import { taoKhungTuLam } from "./tro-ly-vong"; // GĐ4c: khung "Đang tự làm" (tệp riêng)

type LoaiDx = "tao_kich_ban" | "sua_kich_ban" | "chay_thu" | "ghi_bai_hoc" | "doi_che_do_tu_sua" | "tu_lam" | "mo_trang";
interface NguonV { ma: string; loai: string; nhan: string; lienKet: string }
interface DxV { id: number; loai: LoaiDx; moTa: string; trangThai: "cho" | "dang_lam" | "da_lam" | "loi" | "bo_qua"; ketQua: string | null; lienKet: string | null; lamDuoc: boolean }
interface TinV { id: number; vai: "nguoi" | "tro_ly"; noiDung: string; trangThai: "dang_tra_loi" | "xong" | "loi"; loi: string | null; nguon: NguonV[]; deXuat: DxV[]; taoLuc: string; soLieu?: string | null }
interface DsV { items: TinV[]; nextBefore: string | null; dangTraLoi: boolean; coAi: boolean; chu: { id: string; ten: string | null }; chiXem: boolean }

const TOI_DA = 2000;
const dem = (s: string) => Array.from(s.trim()).length;
const maYeuCau = (): string => `tl-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
const TEN_DX: Record<LoaiDx, string> = { tao_kich_ban: "Tạo kịch bản", sua_kich_ban: "Sửa kịch bản", chay_thu: "Chạy thử (cũ)", ghi_bai_hoc: "Ghi bài học", doi_che_do_tu_sua: "Chế độ khi lỗi", tu_lam: "Tự làm (có rào)", mo_trang: "Bạn tự làm" };
const NUT_DX: Record<LoaiDx, string> = { tao_kich_ban: "Tạo kịch bản", sua_kich_ban: "Sửa kịch bản", chay_thu: "Chạy thử", ghi_bai_hoc: "Ghi vào Sổ kinh nghiệm", doi_che_do_tu_sua: "Đổi chế độ", tu_lam: "Bắt đầu tự làm", mo_trang: "" };
const GOI_Y = [
  "Hôm nay các bot đăng được bao nhiêu bài, bao nhiêu bình luận?",
  "Vì sao kịch bản lỗi đêm qua?",
  "Có gì đang chờ tôi duyệt không?",
  "Giúp tôi tạo kịch bản bình luận các bài về phần mềm kiến trúc trên Facebook",
];

export async function renderTroLy(root: HTMLElement, _params: Record<string, string>, query: URLSearchParams): Promise<() => void> {
  const alive = gen("tro-ly");
  let dung = false;
  const hen = new Set<number>();
  const cho = (ms: number) => new Promise<void>((r) => { const t = window.setTimeout(() => { hen.delete(t); r(); }, ms); hen.add(t); });
  const ownerQ = isSuper() ? query.get("ownerId") ?? "" : "";
  const q = ownerQ ? `?ownerId=${encodeURIComponent(ownerQ)}` : "";
  const dau = await api<DsV>("GET", `/api/tro-ly/tin${q}`);
  if (!alive()) return () => {};
  let tins = dau.items;
  let truoc = dau.nextBefore;
  const chiXem = dau.chiXem;

  root.append(h("h1", {}, "Trợ lý"),
    h("p", { class: "small muted giai-thich", "data-testid": "tl-gioi-thieu" }, "Hỏi bằng lời về bot, kịch bản, lần chạy, việc chờ duyệt của bạn — trợ lý trả lời dựa trên dữ liệu thật và ghi rõ nguồn. Trợ lý chỉ ĐỀ XUẤT; bạn bấm nút thì việc mới được làm. Chạy thật, duyệt đăng, tăng hạn mức luôn do bạn tự bấm."));

  // ---- Super: chọn hội thoại của Boss nào để xem ----
  if (isSuper()) {
    const chon = h("select", { "data-testid": "tl-chon-chu", "aria-label": "Hội thoại của", title: "Xem hội thoại trợ lý của một tài khoản (tài khoản khác: chỉ xem)" }, h("option", { value: "" }, "Của tôi"));
    try {
      const us = await api<{ id: string; username: string; role: string }[]>("GET", "/api/users");
      for (const u of us) if (u.id !== store.user?.id) chon.append(h("option", { value: u.id, selected: u.id === ownerQ }, u.username));
    } catch { /* không có danh sách thì chỉ còn "Của tôi" */ }
    if (!alive()) return () => {};
    chon.addEventListener("change", () => { location.hash = chon.value ? `#/tro-ly?ownerId=${encodeURIComponent(chon.value)}` : "#/tro-ly"; });
    root.append(h("div", { class: "row wrap tl-chon" }, h("label", { class: "small muted" }, "Hội thoại của "), chon));
  }
  if (chiXem) root.append(h("p", { class: "warn-box tl-chi-xem", "data-testid": "tl-chi-xem" }, `Bạn đang xem hội thoại trợ lý của “${dau.chu.ten ?? dau.chu.id}” — chỉ xem, không hỏi hay bấm thay được.`));
  if (!dau.coAi && !chiXem) root.append(h("p", { class: "warn-box", "data-testid": "tl-chua-ai" }, "Máy chủ chưa cấu hình AI — Super Boss vào “Mô hình AI” để nhập khoá, sau đó bạn mới hỏi trợ lý được."));

  // GĐ4c: khung "Đang tự làm" (vòng tự làm có rào) — trên hội thoại.
  const vgBox = h("div", { "data-testid": "vg-hop" });
  root.append(vgBox);
  const khungVg = taoKhungTuLam(vgBox, { ownerQ, chiXem: false }); // Dừng là hướng an toàn: Super xem hội thoại người khác vẫn dừng được (máy chủ quyết dungDuoc)
  const xemCu = h("button", { type: "button", class: "mini", hidden: true, "data-testid": "tl-xem-cu", title: "Tải thêm các tin nhắn cũ hơn" }, "Xem tin cũ hơn");
  const ds = h("div", { class: "tl-ds", role: "log", "aria-live": "polite", "aria-label": "Hội thoại với trợ lý", "data-testid": "tl-ds" });
  const goiY = h("div", { class: "tl-goi-y", "data-testid": "tl-goi-y" });
  root.append(h("div", { class: "row center" }, xemCu), ds, goiY);

  // ---- ô gõ ----
  const o = h("textarea", { rows: 3, "data-testid": "tl-o", placeholder: "Hỏi trợ lý… (Enter để gửi, Shift+Enter xuống dòng)", "aria-label": "Câu hỏi cho trợ lý", title: `Tối đa ${TOI_DA} ký tự` });
  const demO = h("span", { class: "small muted", "data-testid": "tl-dem" }, `0/${TOI_DA}`);
  const gui = h("button", { type: "button", class: "pri", "data-testid": "tl-gui", disabled: !dau.coAi, title: "Gửi câu hỏi cho trợ lý" }, "Gửi");
  const loiO = h("div", { class: "err-box", hidden: true, "data-testid": "tl-loi" });
  let yeuCauId = maYeuCau();
  const capNhatDem = () => { const n = dem(o.value); demO.textContent = `${n}/${TOI_DA}`; demO.className = `small ${n > TOI_DA ? "err" : "muted"}`; };
  o.addEventListener("input", () => { capNhatDem(); yeuCauId = maYeuCau(); });
  o.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.isComposing) { e.preventDefault(); gui.click(); }
  });
  const baoLoi = (m: string | null) => { loiO.textContent = m ?? ""; loiO.hidden = !m; };
  gui.addEventListener("click", () => void busy(gui, "Đang gửi…", async () => {
    baoLoi(null);
    const n = dem(o.value);
    if (!n) { baoLoi("Hãy gõ câu hỏi hoặc điều bạn muốn rồi bấm Gửi"); o.focus(); return; }
    if (n > TOI_DA) { baoLoi(`Câu hỏi quá dài (${n}/${TOI_DA} ký tự) — hãy rút gọn`); return; }
    try {
      const r = await api<{ hoi: TinV; traLoi: TinV | null }>("POST", "/api/tro-ly/tin", { noiDung: o.value, yeuCauId });
      if (!alive()) return;
      o.value = ""; capNhatDem(); yeuCauId = maYeuCau();
      for (const t of [r.hoi, r.traLoi]) if (t) datTin(t);
      ve(true);
      if (r.traLoi) void theoDoi(r.traLoi.id);
    } catch (e) { baoLoi(errMsg(e)); }
  }));
  if (!chiXem) root.append(h("div", { class: "card tl-go", "data-testid": "tl-go" }, o, h("div", { class: "row between tl-go-hang" }, demO, gui), loiO));

  function datTin(t: TinV): void {
    const i = tins.findIndex((x) => x.id === t.id);
    if (i >= 0) tins[i] = t; else { tins.push(t); tins.sort((a, b) => a.id - b.id); }
  }

  // ---- theo dõi tin đang trả lời / thẻ đang làm (F5 xong vẫn tiếp tục) ----
  const dangTheoDoi = new Set<number>();
  const conViec = (t: TinV) => t.trangThai === "dang_tra_loi" || t.deXuat.some((x) => x.trangThai === "dang_lam");
  async function theoDoi(id: number): Promise<void> {
    if (dangTheoDoi.has(id)) return;
    dangTheoDoi.add(id);
    let loiMang = 0;
    try {
      while (!dung && alive()) {
        await cho(loiMang ? 2000 : 800);
        if (dung || !alive()) return;
        try {
          const t = await api<TinV>("GET", `/api/tro-ly/tin/${id}`);
          if (dung || !alive()) return;
          loiMang = 0;
          datTin(t);
          ve(false);
          if (!conViec(t)) { if (t.trangThai !== "dang_tra_loi") ve(true); return; }
        } catch (e) {
          loiMang++;
          const el = ds.querySelector<HTMLElement>(`[data-id="${id}"] [data-testid="tl-dang"]`);
          if (el) el.textContent = `Mất kết nối tới máy chủ — đang thử lại… (${errMsg(e)})`;
        }
      }
    } finally { dangTheoDoi.delete(id); }
  }

  // ---- vẽ ----
  function ve(cuoiXuong: boolean): void {
    clear(ds);
    for (const t of tins) ds.append(veTin(t));
    xemCu.hidden = !truoc;
    clear(goiY);
    if (!tins.length) {
      goiY.append(h("p", { class: "empty", "data-testid": "tl-trong" }, chiXem ? "Tài khoản này chưa hỏi trợ lý lần nào." : "Chưa có tin nhắn nào. Hãy hỏi trợ lý bằng lời — ví dụ:"));
      if (!chiXem) goiY.append(h("div", { class: "row wrap tl-goi-y-ds" }, ...GOI_Y.map((g) => h("button", { type: "button", class: "mini tl-goi-y-nut", "data-testid": "tl-goi-y-nut", title: "Chép câu này vào ô gõ", onclick: () => { o.value = g; capNhatDem(); yeuCauId = maYeuCau(); o.focus(); } }, g))));
    }
    if (cuoiXuong && tins.length) ds.lastElementChild?.scrollIntoView({ block: "nearest" });
  }

  function veTin(t: TinV): HTMLElement {
    const el = h("div", { class: `tl-tin tl-${t.vai === "nguoi" ? "nguoi" : "tro-ly"} tt-${t.trangThai}`, "data-testid": "tl-tin", dataset: { id: String(t.id), vai: t.vai, trangThai: t.trangThai } },
      h("div", { class: "tl-ai small muted" }, t.vai === "nguoi" ? (chiXem ? dau.chu.ten ?? "Chủ Boss" : "Bạn") : "Trợ lý", ` · ${fmtTime(t.taoLuc)}`));
    if (t.noiDung) el.append(h("div", { class: "tl-noi-dung", "data-testid": "tl-noi-dung" }, t.noiDung));
    // L-50 (d): số liệu do MÁY đếm (không phải chữ AI) — hiện riêng dưới câu trả lời.
    if (t.soLieu) el.append(h("div", { class: "tl-so-lieu small", "data-testid": "tl-so-lieu", title: "Số liệu do máy đếm từ trang Việc đã làm — không phải do AI viết" }, t.soLieu));
    if (t.trangThai === "dang_tra_loi") el.append(h("div", { class: "tl-dang", "data-testid": "tl-dang" }, "Trợ lý đang trả lời…"));
    if (t.trangThai === "loi") {
      const thuLai = !chiXem ? h("button", { type: "button", class: "mini", "data-testid": "tl-thu-lai", title: "Hỏi lại trợ lý câu này" }, "Thử lại") : null;
      thuLai?.addEventListener("click", () => void busy(thuLai, "Đang gửi…", async () => {
        try { const moi = await api<TinV>("POST", `/api/tro-ly/tin/${t.id}/thu-lai`, {}); datTin(moi); ve(false); void theoDoi(t.id); }
        catch (e) { toast(errMsg(e), "err"); }
      }));
      el.append(h("div", { class: "err-box tl-loi-tin", "data-testid": "tl-loi-tin" }, h("span", {}, t.loi ?? "Trợ lý chưa trả lời được"), thuLai ? " " : null, thuLai));
    }
    if (t.nguon.length) el.append(h("div", { class: "row wrap tl-nguon-ds", "data-testid": "tl-nguon-ds" }, h("span", { class: "small muted" }, "Nguồn:"),
      ...t.nguon.map((n) => h("a", { class: "tl-nguon", href: n.lienKet, "data-testid": "tl-nguon", dataset: { ma: n.ma }, title: `Mở ${n.nhan}` }, `${n.ma} · ${n.nhan}`))));
    for (const x of t.deXuat) el.append(veDx(t, x));
    if (conViec(t)) void theoDoi(t.id);
    return el;
  }

  function veDx(t: TinV, x: DxV): HTMLElement {
    const card = h("div", { class: `tl-dx dx-${x.trangThai}`, "data-testid": "tl-dx", dataset: { id: String(x.id), loai: x.loai, trangThai: x.trangThai } },
      h("div", { class: "row wrap tl-dx-dau" }, h("span", { class: `tag ${x.loai === "mo_trang" ? "warn" : ""}`, "data-testid": "tl-dx-loai" }, TEN_DX[x.loai] ?? x.loai)),
      h("p", { class: "tl-dx-mo-ta", "data-testid": "tl-dx-mo-ta" }, x.moTa));
    if (!x.lamDuoc) {
      if (x.lienKet) card.append(h("a", { class: "btn mini", href: x.lienKet, "data-testid": "tl-dx-mo", title: "Mở trang để bạn tự làm việc này" }, "Mở trang để tự làm"));
      return card;
    }
    if (x.trangThai === "da_lam") card.append(h("p", { class: "small ok tl-dx-kq", "data-testid": "tl-dx-kq" }, `✓ ${x.ketQua ?? "Đã làm"} `, x.lienKet ? h("a", { href: x.lienKet, "data-testid": "tl-dx-mo-kq", title: "Mở kết quả" }, "Mở") : null));
    else if (x.trangThai === "bo_qua") card.append(h("p", { class: "small muted tl-dx-kq", "data-testid": "tl-dx-kq" }, "Đã bỏ qua"));
    else if (x.trangThai === "dang_lam") card.append(h("p", { class: "small tl-dx-kq", "data-testid": "tl-dx-kq" }, "Đang làm…"));
    else if (x.trangThai === "loi") card.append(h("p", { class: "small err tl-dx-kq", "data-testid": "tl-dx-kq" }, x.ketQua ?? "Chưa làm được"));
    if ((x.trangThai === "cho" || x.trangThai === "loi") && !chiXem) {
      const lam = h("button", { type: "button", class: "mini pri", "data-testid": "tl-dx-lam", title: "Làm đúng việc ghi ở thẻ này" }, x.trangThai === "loi" ? `Làm lại: ${NUT_DX[x.loai]}` : NUT_DX[x.loai]);
      const bo = h("button", { type: "button", class: "mini", "data-testid": "tl-dx-bo", title: "Không làm việc này" }, "Bỏ qua");
      const capNhat = (moi: DxV) => { t.deXuat = t.deXuat.map((d) => (d.id === moi.id ? moi : d)); datTin(t); ve(false); };
      lam.addEventListener("click", () => void busy(lam, "Đang làm…", async () => {
        bo.disabled = true;
        try { const moi = await api<DxV>("POST", `/api/tro-ly/de-xuat/${x.id}/lam`, {}); capNhat(moi); if (x.loai === "tu_lam") void khungVg.taiLai(); toast(moi.trangThai === "da_lam" ? moi.ketQua ?? "Đã làm" : moi.ketQua ?? "Chưa làm được", moi.trangThai === "da_lam" ? "info" : "err"); }
        catch (e) { toast(errMsg(e), "err"); try { datTin(await api<TinV>("GET", `/api/tro-ly/tin/${t.id}`)); ve(false); } catch { /* giữ nguyên */ } }
        finally { bo.disabled = false; }
      }));
      bo.addEventListener("click", () => void busy(bo, "…", async () => {
        try { capNhat(await api<DxV>("POST", `/api/tro-ly/de-xuat/${x.id}/bo-qua`, {})); }
        catch (e) { toast(errMsg(e), "err"); }
      }));
      card.append(h("div", { class: "row wrap tl-dx-nut" }, lam, bo));
    }
    return card;
  }

  xemCu.addEventListener("click", () => void busy(xemCu, "Đang tải…", async () => {
    try {
      const r = await api<DsV>("GET", `/api/tro-ly/tin?${new URLSearchParams({ ...(ownerQ ? { ownerId: ownerQ } : {}), before: truoc ?? "" }).toString()}`);
      if (!alive()) return;
      for (const t of r.items) datTin(t);
      truoc = r.nextBefore;
      const moc = ds.firstElementChild;
      ve(false);
      if (moc) ds.querySelector(`[data-id="${(moc as HTMLElement).dataset.id}"]`)?.scrollIntoView({ block: "start" });
    } catch (e) { toast(errMsg(e), "err"); }
  }));

  ve(true);
  if (tins.length && !chiXem) o.scrollIntoView({ block: "nearest" });
  return () => { dung = true; for (const t of hen) clearTimeout(t); hen.clear(); khungVg.huy(); };
}
